export enum AccessMatrixKeys {
  Residents_List_ViewList = 'residents_list_viewList',
  Residents_List_AddNewImportCsv = 'residents_list_addNew/ImportCsv',
  Residents_List_DownloadList = 'residents_list_downloadList',
  Residents_Details_ViewDetails = 'residents_details_viewDetails',
  Residents_Details_AddEditResidentPicture = 'residents_details_add/EditResidentPicture',
  Residents_Details_EditResidentDetails = 'residents_details_editResidentDetails',
  Residents_Details_DeleteProfile = 'residents_details_deleteProfile',
  Residents_Details_DownloadProfile = 'residents_details_downloadProfile',
  Residents_Details_AddFamily = 'residents_details_addFamily',
  Residents_Details_DeleteFamily = 'residents_details_deleteFamily',
  Residents_Details_ViewStoryAndPreferences = 'residents_details_viewStoryAndPreferences',
  Residents_Details_EditStoryAndPreferences = 'residents_details_editStoryAndPreferences',
  Residents_Details_ViewAllCards = 'residents_details_viewAllCards',
  Residents_Details_ManageFamilyNewsletter = 'residents_details_manageFamilyNewsletter',
  Residents_Details_EditSettings = 'residents_details_editSettings',
  Residents_Details_UnassignDevices = 'residents_details_unassignDevices',
  FamilyMembers_List_ViewList = 'familyMembers_list_viewList',
  FamilyMembers_List_ViewBroadcasts = 'familyMembers_list_viewBroadcasts',
  FamilyMembers_List_SendBroadcastNotification = 'familyMembers_list_sendBroadcastNotification',
  FamilyMembers_List_AddNew = 'familyMembers_list_addNew',
  FamilyMembers_Details_ViewDetails = 'familyMembers_details_viewDetails',
  FamilyMembers_Details_EditDetails = 'familyMembers_details_editDetails',
  FamilyMembers_Details_DownloadProfile = 'familyMembers_details_downloadProfile',
  FamilyMembers_Details_DeleteProfile = 'familyMembers_details_deleteProfile',
  FamilyMembers_Details_SendNotification = 'familyMembers_details_sendNotification',
  FamilyMembers_Details_ResetPassword = 'familyMembers_details_resetPassword',
  FamilyMembers_Details_ChangeEpoaNextOfKinStatus = 'familyMembers_details_changeEpoa/NextOfKinStatus',
  FamilyMembers_Details_ChangePoaStatus = 'familyMembers_details_changePoaStatus',
  Calendar_CalendarView_ViewCalendar = 'calendar_calendarView_viewCalendar',
  Calendar_CalendarView_CreateEvent = 'calendar_calendarView_createEvent',
  Calendar_CalendarView_PublishDrafts = 'calendar_calendarView_publishDrafts',
  Calendar_Events_ViewEvent = 'calendar_events_viewEvent',
  Calendar_Events_EditEvent = 'calendar_events_editEvent',
  Calendar_Events_DeleteEvent = 'calendar_events_deleteEvent',
  Calendar_Events_SaveAsDraft = 'calendar_events_saveAsDraft',
  Calendar_Events_TakeAttendance = 'calendar_events_takeAttendance',
  Calendar_Events_AddPictures = 'calendar_events_addPictures',
  Calendar_Events_AddLocation = 'calendar_events_addLocation',
  Calendar_Events_BookRoom = 'calendar_events_bookRoom',
  PrintableCalendar_Edit = 'printableCalendar_edit',
  PrintableCalendar_Download = 'printableCalendar_download',
  PrintableCalendar_GetJsonFeed = 'printableCalendar_getJsonFeed',
  Gallery_MainView_ViewFolders = 'gallery_mainView_viewFolders',
  Gallery_MainView_CreateFolders = 'gallery_mainView_createFolders',
  Gallery_FolderView_UploadImage = 'gallery_folderView_uploadImage',
  DigitalSignage_List_EnableDisableChannels = 'digitalSignage_list_enable/DisableChannels',
  DigitalSignage_List_ManageDevices = 'digitalSignage_list_manageDevices',
  DigitalSignage_List_CreateChannels = 'digitalSignage_list_createChannels',
  DigitalSignage_ChannelView_AddPage = 'digitalSignage_channelView_addPage',
  DigitalSignage_ChannelView_RemovePage = 'digitalSignage_channelView_removePage',
  DigitalSignage_ChannelView_DeleteChannel = 'digitalSignage_channelView_deleteChannel',
  DigitalSignage_ChannelView_EditStyle = 'digitalSignage_channelView_editStyle',
  DigitalSignage_ChannelView_PlayDs = 'digitalSignage_channelView_playDs',
  DigitalSignage_ChannelView_UpdateChannelType = 'digitalSignage_channelView_updateChannelType',
  DigitalSignage_ChannelView_UpdateFacilitiesPublishedTo = 'digitalSignage_channelView_updateFacilitiesPublishedTo',
  DigitalSignage_ChannelView_UpdateNeighbourhoodPublishedTo = 'digitalSignage_channelView_updateNeighbourhoodPublishedTo',
  MediaLibrary_List_ViewList = 'mediaLibrary_list_viewList',
  MediaLibrary_List_ManageContentCategories = 'mediaLibrary_list_manageContentCategories',
  MediaLibrary_List_AddMedia = 'mediaLibrary_list_addMedia',
  MediaLibrary_MediaView_EditMedia = 'mediaLibrary_mediaView_editMedia',
  MediaLibrary_MediaView_DeleteMedia = 'mediaLibrary_mediaView_deleteMedia',
  Creator_List_ViewList = 'creator_list_viewList',
  Creator_List_CreateContent = 'creator_list_createContent',
  Creator_Page_EditContent = 'creator_page_editContent',
  Creator_Page_DeletePage = 'creator_page_deletePage',
  Creator_Page_Save = 'creator_page_save',
  Creator_Page_Publish = 'creator_page_publish',
  LifestylePrograms_List_ViewList = 'lifestylePrograms_list_viewList',
  LifestylePrograms_List_CreateProgram = 'lifestylePrograms_list_createProgram',
  LifestylePrograms_Program_EditProgram = 'lifestylePrograms_program_editProgram',
  LifestylePrograms_Program_AddEvent = 'lifestylePrograms_program_addEvent',
  LifestylePrograms_Program_DeleteProgram = 'lifestylePrograms_program_deleteProgram',
  Concierge_Directory_ViewList = 'concierge_directory_viewList',
  Concierge_Requests_ViewList = 'concierge_requests_viewList',
  Concierge_Requests_ManageDimensions = 'concierge_requests_manageDimensions',
  Concierge_Requests_AddRequest = 'concierge_requests_addRequest',
  Concierge_RequestDetails_EditRequest = 'concierge_requestDetails_editRequest',
  Concierge_RequestDetails_DeleteRequest = 'concierge_requestDetails_deleteRequest',
  Concierge_Events_ViewList = 'concierge_events_viewList',
  Concierge_Events_ManageDimensions = 'concierge_events_manageDimensions',
  Concierge_Events_AddEvent = 'concierge_events_addEvent',
  Concierge_EventDetails_EditEvent = 'concierge_eventDetails_editEvent',
  Concierge_EventDetails_DeleteEvent = 'concierge_eventDetails_deleteEvent',
  Concierge_Products_ViewList = 'concierge_products_viewList',
  Concierge_Products_ManageDimensions = 'concierge_products_manageDimensions',
  Concierge_Products_AddProduct = 'concierge_products_addProduct',
  Concierge_EventDetails_EditProduct = 'concierge_eventDetails_editProduct',
  Concierge_EventDetails_DeleteProduct = 'concierge_eventDetails_deleteProduct',
  Concierge_BookingsAndOrders_ViewList = 'concierge_bookings&Orders_viewList',
  Concierge_BookingsAndOrders_ExportList = 'concierge_bookings&Orders_exportList',
  Concierge_BookingsAndOrders_BookRequest = 'concierge_bookings&Orders_bookRequest',
  Concierge_BookingsAndOrders_BookEvent = 'concierge_bookings&Orders_bookEvent',
  Concierge_BookingsAndOrders_OrderProduct = 'concierge_bookings&Orders_orderProduct',
  Concierge_AppointmentManager_ViewManager = 'concierge_appointmentManager_viewManager',
  Concierge_AppointmentManager_ViewAppointmentDetails = 'concierge_appointmentManager_viewAppointmentDetails',
  Maintenance_Requests_ViewRequests = 'maintenance_requests_viewRequests',
  Maintenance_Requests_CreateRequests = 'maintenance_requests_createRequests',
  Maintenance_Requests_UploadMedia = 'maintenance_requests_uploadMedia',
  Reporting_ViewLifestyleEventsReport = 'reporting_viewLifestyleEventsReport',
  Reporting_ViewLifestyleProgramsReport = 'reporting_viewLifestyleProgramsReport',
  Reporting_ViewConciergeReport = 'reporting_viewConciergeReport',
  Reporting_ViewBookingsAndOrdersReport = 'reporting_viewBookings&OrdersReport',
  Reporting_ViewResident360Report = 'reporting_viewResident360Report',
  Reporting_ViewFamilyReport = 'reporting_viewFamilyReport',
  Reporting_ViewOrganisationalHealthDashboardReport = 'reporting_viewOrganisationalHealthDashboardReport',
  Reporting_ViewActivitiesReport = 'reporting_viewActivitiesReport',
  Reporting_ViewCommunityHealthDashboardReport = 'reporting_viewCommunityHealthDashboardReport',
  Surveys_List_ViewList = 'surveys_list_viewList',
  Surveys_List_CreateSurvey = 'surveys_list_createSurvey',
  Surveys_Survey_EditSurvey = 'surveys_survey_editSurvey',
  Surveys_Survey_PublishSurvey = 'surveys_survey_publishSurvey',
  Surveys_Survey_ViewResults = 'surveys_survey_viewResults',
  Surveys_Survey_ExportResults = 'surveys_survey_exportResults',
  Surveys_Survey_ArchiveSurvey = 'surveys_survey_archiveSurvey',
  Guestbook_CalendarView_View = 'guestbook_calendarView_view',
  Guestbook_CalendarView_CreateVisit = 'guestbook_calendarView_createVisit',
  StaffMessenger_RoomList_ViewList = 'staffMessenger_roomList_viewList',
  StaffMessenger_RoomList_JoinRoom = 'staffMessenger_roomList_joinRoom',
  StaffMessenger_RoomList_CreateRoom = 'staffMessenger_roomList_createRoom',
  StaffMessenger_Room_ViewRoomDetails = 'staffMessenger_room_viewRoomDetails',
  StaffMessenger_Room_LeaveRoom = 'staffMessenger_room_leaveRoom',
  StaffMessenger_Room_SendMessage = 'staffMessenger_room_sendMessage',
  Devices_List_ViewList = 'devices_list_viewList',
  Devices_Device_UnassignDevice = 'devices_device_unassignDevice',
  Settings_UserProfile_ViewProfile = 'settings_userProfile_viewProfile',
  Settings_UserProfile_EditProfile = 'settings_userProfile_editProfile',
  Settings_UserProfile_ResetPassword = 'settings_userProfile_resetPassword',
  Settings_UserProfile_ManageDevices = 'settings_userProfile_manageDevices',
  Settings_UserManagementList_ViewList = 'settings_userManagementList_viewList',
  Settings_UserManagementList_ManageRoles = 'settings_userManagementList_manageRoles',
  Settings_UserManagementList_AddRoles = 'settings_userManagementList_addRoles',
  Settings_UserManagementList_AddUser = 'settings_userManagementList_addUser',
  Settings_UserManagementList_SendUserInvites = 'settings_userManagementList_sendUserInvites',
  Settings_UserDetails_EditDetails = 'settings_userDetails_editDetails',
  Settings_UserDetails_RemoveFacilityAccess = 'settings_userDetails_removeFacilityAccess',
  Settings_UserDetails_DeleteUser = 'settings_userDetails_deleteUser',
  Settings_UserDetails_ResetPassword = 'settings_userDetails_resetPassword',
  Settings_Guestbook_ViewGuestbook = 'settings_guestbook_viewGuestbook',
  Settings_Guestbook_EditGuestbookRules = 'settings_guestbook_editGuestbookRules',
  Settings_Guestbook_AddNewVisitType = 'settings_guestbook_addNewVisitType',
  Settings_Guestbook_DeleteVisitType = 'settings_guestbook_deleteVisitType',
  Settings_Guestbook_EditVisitType = 'settings_guestbook_editVisitType',
  Settings_Facility_ChangeStaffhubLogo = 'settings_facility_changeStaffhubLogo',
  Settings_Facility_ChangeOrgLogo = 'settings_facility_changeOrgLogo',
  Settings_Facility_ChangeFacilityLogo = 'settings_facility_changeFacilityLogo',
  Settings_Facility_Name = 'settings_facility_name',
  Settings_Facility_Currency = 'settings_facility_currency',
  Settings_Facility_Date = 'settings_facility_date',
  Settings_Facility_Time = 'settings_facility_time',
  Settings_Facility_Country = 'settings_facility_country',
  Settings_Facility_Language = 'settings_facility_language',
  Settings_Facility_MyhubSkin = 'settings_facility_myhubSkin',
  Settings_Facility_StaffDirectory = 'settings_facility_staffDirectory',
  Settings_Facility_MediaApps = 'settings_facility_mediaApps',
  Settings_Facility_Checkboxes = 'settings_facility_checkboxes',
  Settings_EmailTemplates_ManageTypes = 'settings_emailTemplates_manageTypes',
  Settings_EmailTemplates_AddNew = 'settings_emailTemplates_addNew',
  Settings_EmailTemplates_SendEmail = 'settings_emailTemplates_sendEmail',
  Settings_EmailTemplates_EditTemplate = 'settings_emailTemplates_editTemplate',
  Settings_EmailTemplates_ChangeDefaultEmailTemplate = 'settings_emailTemplates_change_defaut_emailTemplate',
  Settings_MailingList_AddNew = 'settings_mailingList_addNew',
  Settings_MailingList_EditList = 'settings_mailingList_editList',
  Settings_DeparturesTransfers_DepartTransferResidents = 'settings_departures/Transfers_depart/TransferResidents',
  Settings_GroupingsAndLoc_ManageLevelsOfCare = 'settings_groupingsAndLoc_manageLevelsOfCare',
  Settings_GroupingsAndLoc_ManageLocations = 'settings_groupingsAndLoc_manageLocations',
  Settings_Concierge_ManageVendors = 'settings_concierge_manageVendors',
  Settings_FamilyNewsletter_EditNewsletter = 'settings_familyNewsletter_editNewsletter',
  Settings_Dimensions_ManageDimensions = 'settings_dimensions_manageDimensions',
  Settings_Maintenance_ManageMaintenanceRequestTypes = 'settings_maintenance_manageMaintenanceRequestTypes',
  Settings_Residents_ManageTags = 'settings_residents_manageTags',
  Settings_Activities_ManageActivityTypes = 'settings_activities_manageActivityTypes',
  Settings_Care_ViewAndManageFilters = 'settings_care_viewAndManageFilters',
  Settings_Template_ViewAndManageFilters = 'settings_template_viewAndManageFilters',
  Settings_DeletingForms_ViewAndManageFilters = 'settings_deletingForms_viewAndManageFilters',
  Settings_Facility_ChangeSessionsTimeouts = 'settings_facility_change_sessions_timeouts',
  Settings_SecurityTab = 'settings_securityTab',
  Settings_Security_IpRestriction = 'settings_security_ipRestriction',
  Auth_IntercomAccess = 'auth_intercomAccess',
  FamilyFeedback_ViewList = 'familyFeedback_viewList',
  FamilyFeedback_ViewDetails = 'familyFeedback_viewDetails',
  FamilyFeedback_ManageNotifications = 'familyFeedback_manageNotifications',
}